import useVisitor from 'hooks/useVisitor';
import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { RootState } from 'redux-state/store';

const VisitorTracker = ({ children }: { children: React.ReactNode }) => {
  const user = useSelector((state: RootState) => state.auth.user, shallowEqual);
  const isLoggedIn = useMemo(() => Boolean(user), [user]);

  useVisitor(isLoggedIn);

  return <>{children}</>;
};

export default VisitorTracker;
